<template>
  <div>
    <v-row>
      <v-col cols="2">
        {{ $t('EREPORTER.SELECTED') }}: {{ selectedNumber }}
      </v-col>
      <v-col cols="3">
        <v-switch
          v-model="showListSelect"
          dense
          class="mt-0 pt-0"
          hide-details
          :label="$t('EREPORTER.SHOW_SELECTED')"
          @change="$emit('changeShowSelect', $event)"
        />
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="3">
        <v-select
          v-model="selectedStatus"
          item-value="id"
          item-text="name"
          return-object
          :items="invoiceMassStatuses"
          :label="$t('EREPORTER.SET_STATUS')"
          :disabled="!selected.length"
          @change="setStatus"
        ></v-select>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-btn :disabled="exportPdfIsDisabled()" @click="getPDF()">{{
          $t('BUTTON.PRINT')
        }}</v-btn>

        <v-btn
          class="ml-8"
          :disabled="exportIsNotAvailable()"
          @click="getXls"
          >{{ $t('BUTTON.EXPORT') }}</v-btn
        >

        <v-btn
          :disabled="sendViaEmailsDisabled()"
          class="ml-8"
          @click="popupSendViaEmails()"
          >{{ $t('BUTTON.SEND_EMAIL') }}
        </v-btn>
      </v-col>
    </v-row>

    <confirm-dialog ref="confirm"></confirm-dialog>

    <snacks
      :items="
        invoicesErrors.map(text => {
          return {
            color: 'red accent-2',
            type: 'error',
            message: text
          };
        })
      "
      @clearSnacks="clearInvoicesErrors"
    ></snacks>
  </div>
</template>

<script>
import Snacks from '@/modules/_global/_components/DefaultSnacks';
import downloadFile from '@/modules/_global/mixins/download-file';
import { mapActions, mapState } from 'vuex';
import { isEmpty } from 'lodash';
import {
  PRINTED,
  SENT_TO_ABACUS,
  SENT_VIA_EMAIL
} from '@/modules/ereporter/common/Invoices/statuses';
import i18nRefreshData from '@/modules/_global/mixins/i18nRefreshData';
import { mapCacheActions } from 'vuex-cache';
import { dateFormatUnderscore } from '@/modules/_global/filters';

export default {
  name: 'InvoicesListOptions',

  components: {
    ConfirmDialog: () => import('@/modules/_global/_components/ConfirmDialog'),
    Snacks
  },
  mixins: [downloadFile, i18nRefreshData],

  props: {
    selected: {
      type: Array,
      default: () => []
    },
    invoices: {
      type: Array,
      default: () => []
    },
    filters: {
      type: Object,
      default: () => ({})
    }
  },

  data: () => ({
    selectedStatus: null,
    selectedNumber: 0,
    datetime: '',
    showListSelect: false
  }),

  computed: {
    ...mapState('ereporter', ['invoiceMassStatuses', 'invoicesErrors'])
  },

  created() {
    this.refreshData();
    this.datetime = dateFormatUnderscore(new Date());
  },

  methods: {
    ...mapActions('ereporter', [
      'sendInvoicesViaEmails',
      'getInvoicesExportXls',
      'getInvoicesPdf',
      'updateInvoicesStatuses',
      'clearInvoicesErrors'
    ]),
    ...mapCacheActions('ereporter', ['getInvoiceMassStatuses']),
    refreshData() {
      this.getInvoiceMassStatuses();
    },
    setStatus(status) {
      this.$refs.confirm
        .open(
          this.$t('EREPORTER.INVOICES.MASS_CHANGE_STATUS_QUESTION', {
            count: this.selected.length
          }),
          null,
          {
            cancelBtnText: this.$t(
              'EREPORTER.MASS_CHANGE_STATUS_QUESTION_CANCEL_BUTTON'
            ),
            agreeBtnText: this.$t(
              'EREPORTER.MASS_CHANGE_STATUS_QUESTION_AGREE_BUTTON'
            )
          }
        )
        .then(confirm => {
          if (confirm) {
            this.updateInvoicesStatuses({
              status,
              ids: this.selected.map(i => i.id)
            });
          }
        })
        .finally(() => {
          this.selectedStatus = null;
        });
    },
    getPDF() {
      let ids = this.selected.map(i => i.id);

      this.getInvoicesPdf({ ids: ids })
        .then(response => {
          this.downloadFile(response, `Invoices` + this.datetime + `.pdf`);
        })
        .catch(({ response }) => {
          console.log(response);
        });
    },
    exportPdfIsDisabled() {
      this.selectedNumber = this.selected.map(i => i.id).length;

      return this.selectedNumber === 0;
    },
    getXls() {
      this.getInvoicesExportXls(Object.assign({}, this.filters))
        .then(response => {
          let rootName = this.$t('NAVIGATION.INVOICES');

          this.downloadFile(response, `${rootName} ${this.datetime}.xlsx`);
        })
        .catch(error => {
          this.error = error;
        });
    },

    exportIsNotAvailable() {
      return isEmpty(this.invoices) || isEmpty(this.filters.period);
    },

    sendViaEmailsDisabled() {
      return Boolean(!this.selected.length);
    },
    getCountReadyToSendViaEmailInvoices() {
      let invoicesCount = 0;
      let statusesToSend = [PRINTED, SENT_TO_ABACUS, SENT_VIA_EMAIL];

      this.selected.forEach(invoice => {
        if (statusesToSend.includes(invoice.status_id)) {
          invoicesCount++;
        }
      });

      return invoicesCount;
    },
    popupSendViaEmails() {
      this.$refs.confirm
        .open(
          this.$t('EREPORTER.INVOICES.MASS_SEND_EMAIL_MESSAGE', {
            count: this.getCountReadyToSendViaEmailInvoices()
          }),
          null,
          {
            cancelBtnText: this.$t(
              'EREPORTER.SEND_EMAIL_QUESTION_CANCEL_BUTTON'
            ),
            agreeBtnText: this.$t('EREPORTER.SEND_EMAIL_QUESTION_AGREE_BUTTON')
          }
        )
        .then(confirm => {
          if (confirm) {
            let ids = this.selected.map(i => i.id);
            this.sendInvoicesViaEmails({ ids: ids });
          }
        });
    }
  }
};
</script>

<style scoped></style>
